export const DEFAULT_TAB_TYPES = {
  GLOBAL: 'global',
  LOCAL: 'local',
};

export const DEFAULT_TAB_DEFS = [
  { label: 'Local', value: DEFAULT_TAB_TYPES.LOCAL },
  { label: 'Global', value: DEFAULT_TAB_TYPES.GLOBAL },
];
